export const demoMessages = [
  {
    id: '2',
    subject: 'stest',
    body: 'Elevatus peregrinationes, tanquam varius zelus.',
    created: '2022-02-21 14:02:55',
    created_by: '188',
    message_type: 'job_offer',
    sender: null,
    receiver: 'Recruiter',
    messageStatuses: [
      {
        message_id: '2',
        sent_date: '2022-02-21 14:03:00',
        from_user_id: '189',
        to_user_id: '188',
        from_first_viewed_date: '2022-02-21 14:03:00',
        to_first_viewed_date: '2022-02-21 12:15:49',
        reply_from_message_id: null,
      },
    ],
    jobMatchMessages: [
      {
        message_id: '2',
        job_profile_job_offer_match_id: '2',
        job_profile_username: 'Candidate 188',
      },
    ],
  },
  {
    id: '3',
    subject: 'sdfaefsag dfgserg sdfg',
    body: 'studere virtualiter ducunt ad albus byssus. ',
    created: '2022-02-21 14:04:06',
    created_by: '188',
    message_type: 'job_offer',
    sender: 'Recruiter',
    receiver: null,
    messageStatuses: [
      {
        message_id: '3',
        sent_date: '2022-02-21 14:04:06',
        from_user_id: '188',
        to_user_id: '189',
        from_first_viewed_date: '2022-02-21 14:04:06',
        to_first_viewed_date: '2022-02-21 12:16:14',
        reply_from_message_id: '2',
      },
    ],
    jobMatchMessages: [
      {
        message_id: '3',
        job_profile_job_offer_match_id: '2',
        job_profile_username: 'Candidate 188',
      },
    ],
  },
  {
    id: '4',
    subject: '144',
    body: 'heuretes, nutrix, et gallus. Fluctui altus urbs est.',
    created: '2022-02-21 14:04:37',
    created_by: '188',
    message_type: 'job_offer',
    sender: null,
    receiver: 'Recruiter',
    messageStatuses: [
      {
        message_id: '4',
        sent_date: '2022-02-21 14:04:37',
        from_user_id: '189',
        to_user_id: '188',
        from_first_viewed_date: '2022-02-21 14:04:37',
        to_first_viewed_date: null,
        reply_from_message_id: '2',
      },
    ],
    jobMatchMessages: [
      {
        message_id: '4',
        job_profile_job_offer_match_id: '2',
        job_profile_username: 'Candidate 188',
      },
    ],
  },
];

export const getNumberOfUnreadMessages = (messages) =>
  messages.reduce((acc, msg) => {
    if (msg.sender && !msg.to_first_viewed_date) acc += 1;
    return acc;
  }, 0);
